<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                "informationSetup" | translate
              }}</span>
            </h3>
            <div class="card-toolbar">
              <select (change)="changeLanguage($event)" class="form-select">
                <option
                  *ngFor="let language of languages"
                  [value]="language.code"
                  [selected]="languageCode === language.code"
                >
                  {{ language.name }}
                </option>
              </select>
            </div>
          </div>

          <!-- User List -->
          <div class="card-body py-3">
            <div class="table-responsive">
              <!-- User Table Loading -->
              <div
                *ngIf="loading; else textEditor"
                class="d-flex justify-content-center pb-4"
              >
                <div class="spinner-border text-danger" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <ng-template #textEditor>
                <app-text-editor
                  [(ngModel)]="textEditorValue"
                ></app-text-editor>
                <!-- Submit Button -->
                <div class="d-flex justify-content-end mt-8 gap-3">
                  <button
                    [routerLink]="['']"
                    type="button"
                    class="btn btn-sm btn-secondary cursor-pointer"
                  >
                    {{ "cancel" | translate }}
                  </button>
                  <button
                    type="submit"
                    (click)="saveTextEditor()"
                    class="btn btn-sm btn-dark cursor-pointer"
                  >
                    {{ "save" | translate }}
                  </button>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
